import { Badge, Button, Card, Col, Container, Dropdown, Form, Row, Stack, } from "react-bootstrap";
import { UilBag, UilEllipsisV } from "@iconscout/react-unicons";
import { useEffect, useState } from "react";
import BusinessRenameModal from "./BusinessRenameModal";
import DeleteModal from "../../shared/components/DeleteModal";
import { useDispatch, useSelector } from "react-redux";
import { deleteBusiness, resetBusiness } from "../store/businessSlice";
import { toast, ToastContainer } from "react-toastify";
import { setCurrentTenant } from "../../shared/store/sharedSlice";
import { useNavigate } from "react-router-dom";
import format from "date-fns/format";
import { resetPlans } from "../../billing/store/plansSlice";
import { resetOrders } from "../../billing/store/ordersSlice";
import { fetchAllTenants } from "../../auth/store/authSlice";

const BusinessDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { accessToken, user, tenants } = useSelector((state) => state?.auth);
  //const user = useSelector((state) => state?.userProfile?.data);






  const [renameModal, setRenameModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [tenantId, setTenantId] = useState();
  const [userId, setUserId] = useState();
  const [dropdownStates, setDropdownStates] = useState(
    Array(tenants?.length).fill(false)
  );
  const { status, error, success, updateData, deleteStatus } = useSelector(
    (state) => state?.business
  );

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(resetBusiness());
      setRenameModal(false);
      setDeleteModal(false);
    }
  }, [error]);

  useEffect(() => {
    if (status) {
      toast.success(success);
      setRenameModal(false);
      setDeleteModal(false);
      if (deleteStatus) {
        dispatch(fetchAllTenants(userId));

        if (tenantId?.id == user?.currentTenant) {
          window.parent.postMessage(
            {
              action: "tenant_delete",
              userId: userId,
              tenantId: tenantId,
              is_active: true,
            },
            "*"
          );
        } else {
          window.parent.postMessage(
            {
              action: "tenant_delete",
              userId: userId,
              tenantId: tenantId,
              is_active: false,
            },
            "*"
          );
        }
      } else {
        dispatch(fetchAllTenants(userId));
        window.parent.postMessage(
          { action: "tenant_modified", userId: userId },
          "*"
        );
      }
      dispatch(resetBusiness());
    }
  }, [status, deleteStatus]);

  const handleToggle = (index) => {
    setDropdownStates((prevState) =>
      prevState.map((state, i) => (i === index ? !state : state))
    );
  };

  const handleRename = (value) => {
    setRenameModal(true);
    setTenantId(value?.id);
    setUserId(value?.pivot?.user_id);
  };

  const handleDelete = (value) => {
    // if (value?.id == user?.currentTenant) {
    //   window.parent.postMessage(
    //     {
    //       action: "tenant_delete",
    //       is_active: true,
    //       userId: value?.pivot?.user_id,
    //       tenantId: value,
    //     },
    //     "*"
    //   );
    // } else {
    //   window.parent.postMessage(
    //     {
    //       action: "tenant_delete",
    //       userId: value?.pivot?.user_id,
    //       tenantId: value,
    //       is_active: false,
    //     },
    //     "*"
    //   );
    // }
    if (tenants.length > 1) {
      setDeleteModal(true);
      setTenantId(value);
      setUserId(value?.pivot?.user_id);
    } else {
      toast.info("This business cannot be deleted.");
    }
  };

  const handleBusinessChange = (value) => {
    window.parent.postMessage(
      { action: "tenant_switch", tenant_id: value },
      "*"
    );
  };

  const goToBilling = (tenant) => {
    dispatch(resetPlans())
    dispatch(resetOrders())
    navigate('/plan/billing')
    dispatch((setCurrentTenant(tenant)))
  };

  const onDelete = () => {
    dispatch(deleteBusiness(tenantId?.id));
  };

  return (
    <Container fluid className="mt-3 " style={{ border: "none" }}>
      <ToastContainer />
      {tenants &&
        tenants.length > 0 &&
        tenants.map((data, index) => {
          const businessName = data?.business_name || "";
          const initials = businessName
            .split(" ")
            .map(word => word.charAt(0).toUpperCase())
            .join("");
          const flavor = (data?.flavor || "").toLowerCase();
          const flavorLabel =
            flavor === "fitplusclub" ? "Fitplusclub" :
            flavor === "billplus" ? "Billplus" :
            data?.flavor || "";
          const flavorStyles =
            flavor === "fitplusclub"
              ? { backgroundColor: "#0D47A1", color: "#FFFFFF" } // dark blue
              : flavor === "billplus"
              ? { backgroundColor: "#03A9F4", color: "#FFFFFF" } // sky blue
              : { backgroundColor: "#ECEFF1", color: "#37474F" };

          return (
            <Row>

              <Col md={4} key={index} className="mb-4">
                <Card className=" position-relative "
                  style={{
                    borderRadius: "10px",
                    border: data?.id == user?.currentTenant ? '1px solid #0099fb' : '1px solid lightgray'
                  }}>

                  <Card.Body className="py-2 px-3">
                    <Row>
                      {data?.id == user?.currentTenant && (
                        <Col xs="auto" className="mb-0 ">
                          {/* <Badge bg="info">Active</Badge> */}
                          <text className="bold text-info">Active</text>
                        </Col>
                      )}

                    </Row>
                    <Row className="d-flex flex-wrap align-items-center justify-content-between">
                      <Col xs="auto" className="flex-grow-1">
                        <Form.Label className="bold text-truncate mb-0">
                          {data?.business_name}
                        </Form.Label>
                        {flavorLabel && (
                          <div className="mt-1">
                            <span
                              className="px-2 py-1"
                              style={{
                                borderRadius: "12px",
                                fontSize: "11px",
                                fontWeight: 500,
                                ...flavorStyles,
                              }}
                            >
                              {flavorLabel}
                            </span>
                          </div>
                        )}
                      </Col>


                      {data?.pivot?.is_owner === 1 && (
                        <Col xs="auto" className="ms-auto">
                          <Dropdown show={dropdownStates[index]} onToggle={() => handleToggle(index)}>
                            <Dropdown.Toggle
                              as="div"
                              className="border d-flex align-items-center justify-content-center"
                              style={{
                                borderRadius: "5px",
                                height: "30px",
                                width: "30px",
                                cursor: "pointer",
                              }}
                            >
                              <UilEllipsisV size="22" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu align="end">
                              <Dropdown.Item onClick={() => goToBilling(data)}>Billing</Dropdown.Item>
                              <Dropdown.Item onClick={() => handleRename(data)}>Rename</Dropdown.Item>
                              <Dropdown.Item className="text-danger" onClick={() => handleDelete(data)}>
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </Col>
                      )}
                    </Row>

                    <Row className="d-flex justify-content-between align-items-center flex-nowrap mt-1">
                      <Col xs="auto" className="text-nowrap">
                        <Form.Label className="mb-1" style={{ fontSize: '12px', color: 'gray' }}>
                          Business ID
                        </Form.Label>
                        <br />
                        <Form.Label># {data?.business_id}</Form.Label>
                      </Col>
                      <Col xs="auto" className="text-nowrap">
                        <Form.Label className="mb-1" style={{ fontSize: '12px', color: 'gray' }}>
                          Business Created on
                        </Form.Label>
                        <br />
                        <Form.Label>
                          {data?.created_at ? format(new Date(data?.created_at), "dd/MM/yyyy") : ""}
                        </Form.Label>
                      </Col>
                      <Col xs="auto" className="">
                        {data?.pivot?.is_owner == 1 ? (
                          <div className="px-3 py-1" style={{ backgroundColor: '#D4EDDA', borderRadius: '5px', color: '#155724' }}>
                            <text >Owner</text>
                          </div>

                        ) : (
                          <div className="px-3 py-1" style={{ backgroundColor: '#FFECB3', borderRadius: '5px', color: '#FF8F00' }}>
                            <text >User</text>
                          </div>

                        )}
                      </Col>
                    </Row>


                  </Card.Body>
                </Card>

              </Col>

            </Row>);
        })}

      {renameModal && (
        <BusinessRenameModal
          tenantId={tenantId}
          show={renameModal}
          setRenameModal={setRenameModal}
        />
      )}
      {deleteModal && (
        <DeleteModal
          deleteUserClick={onDelete}
          onClickDeleteModel={setDeleteModal}
        //name={title}
        />
      )}
    </Container>
  );
};

export default BusinessDetails;
